import { modulePermissionsSelectors } from '@va/dashboard/selectors/core';

/** @deprecated use {@link modulePermissionsSelectors.isModuleEnabled} from `@va/dashboard/selectors/core` instead */
export const isModuleEnabled = modulePermissionsSelectors.isModuleEnabled; // TODO Update imports and remove
